import { configureStore } from '@reduxjs/toolkit';
import appSlice from './appSlice';
import calculatorStore from '@/store/calculatorStore';
import parcelTracking from '@/store/parcelTracking';

export const store = configureStore({
    reducer: {
        appSlice: appSlice,
        calculatorStore: calculatorStore,
        tracking: parcelTracking,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
